import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCopyCommissionRate extends Layout {
    sourceCommissionRate: DataSource;
    textboxDescription: Textbox;
    textboxRateCode: Textbox;
}
